module.exports = __webpack_public_path__ + "static/media/githubIcon.f2f6b15e.svg";